<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">ADD FACILITY PRICING PARAMETER</h3>
      </div>
      <v-form @submit.prevent="addPricingParameter()">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Name"
                v-model="pricing_parameter.facility_parameter_name"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Default value"
                v-model="pricing_parameter.parameter_default_value"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Min person per Booking"
                v-model="pricing_parameter.facility_min_person"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-text-field
                label="Max person per Booking"
                v-model="pricing_parameter.facility_max_person"
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-switch
                label="Is Price Point"
                color="primary"
                v-model="pricing_parameter.facility_pricing_point"
                required
              ></v-switch>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-switch
                label="Controls Inventory?"
                color="primary"
                v-model="pricing_parameter.facility_control_inventory"
                required
              ></v-switch>
            </v-container>
          </v-flex>
          <v-flex lg4 md4 sm12 xs12>
            <v-container>
              <v-switch
                label="Is Mandatory?"
                color="primary"
                v-model="pricing_parameter.facility_mandatory"
                required
              ></v-switch>
            </v-container>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" color="primary" type="submit" :loading="$loadingTrue"
                >ADD PRICING PARAMETER</v-btn
              >
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <table cellpadding="1" cellspacing="1" class="table table-bordered">
        <thead>
          <tr>
            <td>Date Created</td>
            <td>Name</td>
            <td>Controls Inventory</td>
            <td>Has Price Point</td>
            <td>Action</td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(pricingParameter, key) in facilityPricingParameter"
            :key="key"
          >
            <td>{{ formated_date(pricingParameter.created_at) }}</td>
            <td v-if="pricingParameter.facility_mandatory === 1">
              {{ pricingParameter.facility_parameter_name
              }}<span class="grey--text">(Mandatory)</span>
            </td>
            <td v-else-if="pricingParameter.facility_mandatory === 0">
              {{ pricingParameter.facility_parameter_name }}
            </td>
            <td v-if="pricingParameter.facility_control_inventory === 1">
              TRUE
            </td>
            <td v-else-if="pricingParameter.facility_control_inventory === 0">
              FALSE
            </td>
            <td v-if="pricingParameter.facility_pricing_point === 1">TRUE</td>
            <td v-else-if="pricingParameter.facility_pricing_point === 0">
              FALSE
            </td>
            <td>
              <v-btn
                :depressed="true"
                small
                color="success"
                @click="_showEditDialog(pricingParameter)"
              >
                <v-icon>edit</v-icon>
              </v-btn>
              <v-dialog
                v-model="edit_facility_pricing_dialog"
                persistent
                max-width="700px"
              >
                <v-card>
                  <v-card-title>
                    <h4 class="earth-color">EDIT PRICING PARAMETER</h4>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            label="Name"
                            v-model="
                              edit_pricing_parameter.facility_parameter_name
                            "
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            label="Default value"
                            v-model="
                              edit_pricing_parameter.parameter_default_value
                            "
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            label="Min person per Booking"
                            v-model="edit_pricing_parameter.facility_min_person"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md6>
                          <v-text-field
                            label="Max person per Booking"
                            v-model="edit_pricing_parameter.facility_max_person"
                            :rules="requiredRules"
                            required
                          ></v-text-field>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                          <v-switch
                            label="Is Price Point"
                            color="primary"
                            v-model="
                              edit_pricing_parameter.facility_pricing_point
                            "
                            required
                          ></v-switch>
                        </v-flex>

                        <v-flex xs12 sm12 md4>
                          <v-switch
                            label="Controls Inventory?"
                            color="primary"
                            v-model="
                              edit_pricing_parameter.facility_control_inventory
                            "
                            required
                          ></v-switch>
                        </v-flex>
                        <v-flex xs12 sm12 md4>
                          <v-switch
                            label="Is Mandatory?"
                            color="primary"
                            v-model="edit_pricing_parameter.facility_mandatory"
                            required
                          ></v-switch>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="edit_facility_pricing_dialog = false"
                      >Close</v-btn
                    >
                    <v-btn color="green" flat @click="editPricingParameter"
                      >Update</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-btn
                :depressed="true"
                small
                color="error"
                @click="deletePricingParameter(pricingParameter.public_id)"
                ><v-icon>clear</v-icon></v-btn
              >
            </td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "pricing-parameters",
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],
      edit_facility_pricing_dialog: false,
      pricing_parameter: {
        facility_parameter_name: "",
        parameter_default_value: 0,
        facility_pricing_point: true,
        facility_control_inventory: true,
        facility_min_person: null,
        facility_max_person: null,
        facility_mandatory: false,
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id,
       
      },
      edit_pricing_parameter: {
        facility_parameter_name: "",
        parameter_default_value: "",
        facility_pricing_point: "",
        facility_control_inventory: "",
        facility_min_person: null,
        facility_max_person: null,
        facility_mandatory: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id
      }
    };
  },
  methods: {
    addPricingParameter: function() {
      this.$store.dispatch(
        "post_facility_pricing_parameter",
        this.pricing_parameter
      )
  
    },
    _showEditDialog(pricingParameter) {
      this.edit_facility_pricing_dialog = true;

      this.edit_pricing_parameter.public_id = pricingParameter.public_id;

      this.edit_pricing_parameter.facility_parameter_name =
        pricingParameter.facility_parameter_name;
      this.edit_pricing_parameter.parameter_default_value =
        pricingParameter.parameter_default_value;
      this.edit_pricing_parameter.facility_min_person =
        pricingParameter.facility_min_person;

      this.edit_pricing_parameter.facility_max_person =
        pricingParameter.facility_max_person;

      if (pricingParameter.facility_pricing_point == 1) {
        this.edit_pricing_parameter.facility_pricing_point = true;
      } else {
        this.edit_pricing_parameter.facility_pricing_point = false;
      }
      if (pricingParameter.facility_control_inventory == 1) {
        this.edit_pricing_parameter.facility_control_inventory = true;
      } else {
        this.edit_pricing_parameter.facility_control_inventory = false;
      }
      if (pricingParameter.facility_mandatory == 1) {
        this.edit_pricing_parameter.facility_mandatory = true;
      } else {
        this.edit_pricing_parameter.facility_mandatory = false;
      }
    },
    editPricingParameter: function() {
      this.edit_facility_pricing_dialog = false;
      this.$store.dispatch(
        "edit_facility_pricing_parameter",
        this.edit_pricing_parameter
      );
    },

    deletePricingParameter: function(publicId) {
    
      var data = {
        public_id: publicId,
        facility_id: this.$route.params.facility_id,
        deleted_by: localStorage.getItem("lkjhgfdsa")
      };
      this.$store.dispatch("delete_a_facility_pricing_parameter", data);
      this.$store.dispatch(
        "get_facility_pricing_parameter",
        this.$route.params.facility_id
      );
    }
  },
  created() {

  
    this.$store.dispatch("get_all_facility_allocations");
    this.$store.dispatch(
      "get_facility_pricing_parameter",
      this.$route.params.facility_id
    );
  }
};
</script>

<style scoped></style>
